module.exports = __webpack_public_path__ + "img/chinese-mapo-tofu-met-kip.1cb5ce64.jpeg";